// Constant values used for creating styles with Aphrodite
// The z-index of any element must be 401 to display above the Leaflet map canvas
export const aboveLeafletMap = '401'
